<template>
  <transition appear>
    <div class="waiting-timer-video-room" v-if="timer > 0">
      <i class="el-icon-loading"></i>
      <!-- {{$t('broadcast_connect')}} ({{ this.timer }}) -->
    </div>
    <div v-else data-component="VideoRoom" id="VideoRoomWrapperStage" class="room stage">
      <div class="video-area" :class="this.fullscreenevent ? 'fullscreen-wrapper' : ''">
        <video :class="this.fullscreenevent ? 'fullscreen-event' : ''" preload="none" id="videoRoomPlayer" autoplay crossorigin playsinline :data-poster="currentEvent.image != null ? $imageus + currentEvent.image + '?width=1120&height=500' : '/static/blank.png'"></video>
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      liveComponent:false,
      fullscreenevent: false,
      options: {
        debug: false,
        clickToPlay: true,
        settings: ["quality"],
        controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "pip", "fullscreen"]
      },
      interval: null,
      source: null,
      hls: null,
      timer: 3,
      timeout: null
    };
  },
  beforeMount(){
    this.liveComponent = true;
  },
  mounted() {
    if (this.interval != null) clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.timer--;
      if (this.timer < 0) {
        const video = document.querySelector("#videoRoomPlayer");
        this.source = "https://rtmp2.holacon.com/live/" + this.getCurrentSession.id + "/index.m3u8?sign=" + this.getLiveSessionHash;
        console.log(this.source, "source");
        if (Hls.isSupported()) {
          // HLS PLAYER
          this.createHls();
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
          // HLS MOBILE PLAYER FOR IOS

          video.src = this.source;
          //video.src = `https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8`; // FOR TEST
          video.addEventListener("canplay", function() {
            video.play();
            console.log("Video has started HLS Native Player");
          });
        }
        // else if (flvjs.isSupported()) { // OLD PLAYER FLV WS
        //   var flvPlayer = flvjs.createPlayer(
        //     {
        //       isLive: true,
        //       type: "flv",
        //       url: `wss://rtmp.holacon.com/live/${this.getCurrentSession.id}.flv?sign=${this.getHash}`
        //     },
        //     {
        //       enableWorker: false, // Do not enable detach threads
        //       enableStashBuffer: false, // close IO Hide buffer
        //       reuseRedirectedURL: true, // reusing 301/302 Redirect url, For subsequent requests , Such as search 、 Reconnect, etc .
        //       autoCleanupSourceBuffer: true // Automatically clear cache
        //     }
        //   );
        //   flvPlayer.attachMediaElement(video);
        //   flvPlayer.load();
        //   flvPlayer.play();
        //   console.log("Video has started FLV WS Player");
        // }
        else {
          // MPEG - DASH PLAYER
          var mpd = `https://rtmp2.holacon.com/live/${this.getCurrentSession.id}/index.mpd?sign=${this.getLiveSessionHash}`;
          //var mpd = `https://dash.akamaized.net/akamai/bbb_30fps/bbb_30fps.mpd`; // FOR TEST
          this.$nextTick(() => {
            var dash = dashjs.MediaPlayer().create();
            dash.initialize(video, mpd, true);
            video.play();
            console.log("Video has started MPEG-DASH Player");
          });
        }

        // Update caption tracks after initializing Plyr to get the generated captions
        // For more options see: https://github.com/sampotts/plyr/#options
        const player = new Plyr(video, this.options);

        // Expose player and dash so they can be used from the console
        window.player = player;
        //window.dash = dash;

        //DOCUMENTATION : https://github.com/sampotts/plyr
        player.on("enterfullscreen", event => {
          this.fullscreenevent = true;
        });

        player.on("exitfullscreen", event => {
          this.fullscreenevent = false;
        });
        clearInterval(this.interval);
      } else {
        console.log(this.timer, " Loading Screen");
      }
    }, 1000);
  },
  methods: {
    hlsError(event, data) {
      console.warn("Hata oluştu HLS:", event, data);
      if (this.hls != null) {
        this.hls.off("hlsError", this.hlsError);
        this.hls.destroy();
        this.hls = null;
      }
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        console.log("HLS Re Create");
        this.createHls();
      }, 2000);
    },
    createHls() {
      if(!this.liveComponent) return;
      const video = document.querySelector("#videoRoomPlayer");
      if (this.hls != null) {
        this.hls.destroy();
      }
      this.hls = new Hls();
      this.hls.loadSource(this.source);
      // hls.loadSource(`https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8`); // FOR TEST
      this.hls.attachMedia(video);
      this.hls.on(Hls.Events.MANIFEST_PARSED, function() {
        video.play();
        console.log("Video has started HLS Player");
      });
      if (this.hls != null) {
        this.hls.on("hlsError", this.hlsError);
      }
    },
    changeSelectedURL(url) {
      this.selectedURL = url;
    }
  },

  beforeDestroy() {
    this.liveComponent = false;
    clearInterval(this.timer);
    this.hls = null;
  },

  computed: {
    getLiveSessionHash() {
      return this.$store.getters.getLiveSessionHash;
    },
    vimeoWidth() {
      return window.innerWidth - 500;
    },
    vimeoHeight() {
      return window.innerHeight - 250;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    getCurrentSession() {
      return this.$store.getters.getCurrentSession;
    },
    getParticipantID() {
      return this.$store.state.participant.item.id;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/media/VideoRoom.vue